import React, { useContext } from 'react'
import { OaRtLmpIoHeaders } from './../Headers'
import { EditableGrid } from 'core'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import {
  defaultVirtualizedCellRender,
  freeEditEngine,
} from '@integec/grid-tools'
import { Button, Modal, message, Spin } from 'antd'
import { marginAnalysisValidate } from 'api/pgads'
import { SpinContext, ErrorContext } from 'context'
import moment from 'moment'

const PriceEditGridDioalog = ({
  targetInfo,
  visible,
  onClose,
  height,
  width,
  whatIfAdmin,
  lostType = '1',
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const {
    WFRetrieveData = {},
    priceDataEditInfo,
    setPriceDataEditInfo,
    handleWFRetrieveData,
  } = useContext(MarginAnalysisContext)
  const { priceData = [] } = WFRetrieveData

  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  // const [data, setData] = useState([...priceData])

  const saveData = _ => {
    if (!whatIfAdmin) {
      onClose()
      return
    }

    const { request, priceData } = WFRetrieveData

    let savePriceData = freeEditEngine.applyEdits({
      data: priceData,
      editInfo: priceDataEditInfo,
    })

    if (
      savePriceData.find(
        d =>
          (d.transdateStr || '').trim().length === 0 ||
          (d.pnodeid || '').trim().length === 0
      )
    ) {
      message.error('Please, Correct data')
      return
    }

    savePriceData = savePriceData.map(d => ({
      ...d,
      transdate: moment(d.transdateStr).format('YYYY-MM-DD'),
      isValidDate: moment(d.transdateStr).isValid(),
    }))

    if (savePriceData.find(d => !d.isValidDate)) {
      message.error('Please,Correct Date')
      return
    }

    setSpinning(true)
    marginAnalysisValidate(targetInfo)({
      ...WFRetrieveData,
      priceData: savePriceData,
      request: { ...request, lostType, mode: 'WHATIF' },
    }).fork(setError, data => {
      setSpinning(false)
      handleWFRetrieveData(data, onClose)
    })
  }

  return (
    <Modal
      maskClosable={false}
      title={whatIfAdmin ? 'Edit Prices' : 'View Prices'}
      height={height}
      width={width}
      visible={visible}
      onCancel={onClose}
      okText="Save"
      onOk={saveData}
      destroyOnClose
      afterClose={onClose}
      bodyStyle={{ minHeight: height + 'px' }}
      confirmLoading
      footer={
        <div>
          <Button onClick={onClose} loading={spinning}>
            Cancel
          </Button>
          <Button
            style={{ marginLeft: '20px' }}
            type="primary"
            onClick={saveData}
            loading={spinning}
          >
            {whatIfAdmin ? 'Save Prices' : 'OK'}
          </Button>
        </div>
      }
    >
      <Spin spinning={spinning}>
        <EditableGrid
          isEditable={whatIfAdmin}
          height={height - 20}
          width={width - 50}
          header={OaRtLmpIoHeaders}
          setEditInfo={setPriceDataEditInfo}
          data={priceData}
          editInfo={priceDataEditInfo}
          setData={_ => _}
          cellRender={defaultVirtualizedCellRender}
          headerRowHeight={30}
        />
      </Spin>
    </Modal>
  )
}

export default PriceEditGridDioalog
